import React, { FC } from "react";
import styled from "styled-components";

const Spacer: FC = (props) => {
  return <SpacerContainer {...props} />;
};

const SpacerContainer = styled.div`
  flex-grow: 1;
`;

export default Spacer;
